import { render, staticRenderFns } from "./AppShare.vue?vue&type=template&id=c8b41db2&scoped=true"
import script from "./AppShare.vue?vue&type=script&lang=js"
export * from "./AppShare.vue?vue&type=script&lang=js"
import style0 from "./AppShare.vue?vue&type=style&index=0&id=c8b41db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b41db2",
  null
  
)

export default component.exports